import { FC, Fragment } from 'react';
import { PerformMultiSelect } from '../perform-indicator/perform-indicator';
import {
    CustomerFilterDto,
    CustomFieldsFilterDto,
    CustomFieldsFilterItem,
} from '@servicetitan/application-data/marketing';
import * as Styles from './segment-parts.module.less';

interface LocationProps {
    segmentId: number;
    location: Partial<CustomerFilterDto>;
    customFields?: CustomFieldsFilterDto;
    CustomFieldsComponent?: FC<{
        segmentId: number;
        type: string;
        filters?: CustomFieldsFilterItem[];
    }>;
}

export const Location: FC<LocationProps> = ({
    segmentId,
    location,
    customFields,
    CustomFieldsComponent,
}) => (
    <Fragment>
        <div className={Styles.segmentCardKpiName}>Location</div>
        {location && (
            <div>
                <PerformMultiSelect name="Location Zip Code" value={location.locationZipCodes} />
                <PerformMultiSelect name="Location Tag" value={location.locationTags} />
                <PerformMultiSelect name="Zone" value={location.zones} />
                <PerformMultiSelect name="City" value={location.cities} />
            </div>
        )}
        {CustomFieldsComponent && (
            <CustomFieldsComponent
                segmentId={segmentId}
                type="locationCustomFields"
                filters={customFields?.filters}
            />
        )}
    </Fragment>
);
